<!--suppress CssUnusedSymbol, CssInvalidPropertyValue, CssInvalidFunction, CssUnknownProperty -->
<template>
  <section id="video" class="section-shaped m-0 bg-default pb-4 pt-0">
    <div class="row row-grid justify-content-center py-5">
      <h1 class="text-white">Conheça o Portal Janela Única</h1>
    </div>
  <b-container class="my-2">
    <div style="padding:56.25% 0 0 0;position:relative;">
      <iframe
        src="https://player.vimeo.com/video/384835472?title=0&byline=0&portrait=0"
        style="position:absolute;top:0;left:0;width:100%;height:100%;"
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen>
      </iframe>
    </div>
  </b-container>
  </section>
</template>

<script>
  export default {
    name: 'SectionVideoInstitucional',
  }
</script>
